import React from "react";
import { StyleSheet, View } from 'react-native'
import { useNavigation, useRoute } from '@react-navigation/native'
import { colorList } from 'utils/colors'
import i18n from 'utils/i18n'
import _ from 'lodash'
import TextDivider from 'components/atoms/TextDivider'
import ThemedBlock from 'components/atoms/ThemedBlock'
import ThemedItem from 'components/atoms/ThemedItem'
import HelperString from 'utils/helper-string'
import ThemedPressable from 'components/atoms/ThemedPressable'
import { useSelector } from 'react-redux'
import { constantsActive } from 'utils/constants/constants'
import { bookingOptions } from 'utils/constants/booking-constants'
import { AppRoutes } from 'navigations/app-routes'
import ThemedList from 'components/atoms/ThemedList'
import Translate from "utils/translate";
import { settingsConstants } from 'utils/constants/settings-constants'
import IconView from 'scenes/home/more/index/component/IconView'
import { BookOption } from 'scenes/home/book/start/_components/BookOption'
import useRouteParametersForcedGuids from 'utils/hooks/use-route-parameters-forced-guids'
import selectSetting from 'services/redux/data/selectors/selectSetting'
import { TESTID } from '_shared/config/testID'
import HelperTestID from 'utils/HelperTestID'
import useSelectTimeslotGroups from 'utils/hooks/use-select-timeslot-groups'
import Icon from 'components/atoms/Icon'
import { IconSystemConstants } from 'utils/constants/IconNameConstants'
import * as AppLink from 'react-native-app-link'
import teamsIconPng from 'assets/external/teams-icon.png'

const HomeBookStartPlace = () => {
	
	const navigation = useNavigation();
	const route = useRoute();
	const _forcedGuids = useRouteParametersForcedGuids( route );
	const _timeslotGroups = useSelectTimeslotGroups( _forcedGuids );
	const _settingEvents = useSelector( state => {
		return selectSetting(state, settingsConstants.HM_EVENTS_ENABLED);
	} )
	const showEvents = _settingEvents === constantsActive.YES && !( _.size( _forcedGuids ) > 0 );
	
	const onPressEvents = () => {
		navigation.navigate( AppRoutes.EVENTS );
	}
	
	const onPressMeeting = () => {
		//Linking.openURL( 'https://teams.microsoft.com/l/meeting/new' )
		//return
		
		AppLink.maybeOpenURL( 'msteams://', {
			appName: 'Microsoft Teams',
			appStoreId: '1113153706',
			playStoreId: 'com.microsoft.teams'
		} );
	}
	
	const items = [];
	_.forEach( _timeslotGroups, ( timeslotGroup ) => {
		
		if( timeslotGroup.active === constantsActive.NO || _.size( timeslotGroup.buildingTree ) === 0 ){
			return true;
		}
		
		const options = [];
		if( timeslotGroup.can_book_for_self === constantsActive.YES ) {
			options.push(
				<BookOption
					key={ HelperString.hash('book-option-place', 'self' ) }
					timeslotGroup={ timeslotGroup }
					forOption={ bookingOptions.MYSELF }
					forcedGuids={ _forcedGuids }
		       />
			);
		}
		
		if( timeslotGroup.can_book_for_self === constantsActive.YES && ( timeslotGroup.can_book_for_coworkers === constantsActive.YES || timeslotGroup.can_book_for_external === constantsActive.YES ) ) {
			options.push(
				<BookOption
					key={ HelperString.hash('book-option-place', 'self-and-co' ) }
					timeslotGroup={ timeslotGroup }
					forOption={ bookingOptions.MYSELF_AND_COWORKERS }
					forcedGuids={ _forcedGuids }
				/>
			);
		}
		
		if( timeslotGroup.can_book_for_coworkers === constantsActive.YES || timeslotGroup.can_book_for_external === constantsActive.YES ) {
			options.push(
				<BookOption
					key={ HelperString.hash('book-option-place', 'co' ) }
					timeslotGroup={ timeslotGroup }
					forOption={ bookingOptions.COWORKERS }
					forcedGuids={ _forcedGuids }
				/>
			);
		}
		
		if( _.size( options ) > 0 ){
			items.push(
				<View
					key={ HelperString.hash('start-place', timeslotGroup.guid ) }
					testID={ HelperTestID.generate( TESTID.HOME.BOOK.START.TIMESLOT_GROUP.VIEW, timeslotGroup.guid ) }>
					
					<TextDivider
						text={ Translate.field( timeslotGroup, 'title' ) }
						rowStyle={ staticStyles.textDividerMarginTop12 }
					/>
					
					<ThemedBlock
						shadow>
						
						<ThemedList
							key={ HelperString.hash('start-tab-place', timeslotGroup.guid )}
							data={ options }
							renderItem={ ({ item }) => {
								return item;
							} }
							style={ staticStyles.themedListPaddingHorizontal0 }
						/>
					</ThemedBlock>
				</View>
			)
		}
	});
	
	// EXTERNAL TEST
	if( false ) {
		items.push(
			<View
				key={ HelperString.hash('start-place', 'test' ) }
				testID={ HelperTestID.generate( TESTID.HOME.BOOK.START.TIMESLOT_GROUP.VIEW, 'test' ) }>
				
				<TextDivider
					text={ 'Meeting room' }
					rowStyle={ staticStyles.textDividerMarginTop12 }
				/>
				
				<ThemedBlock
					shadow>
					
					<ThemedList
						key={ HelperString.hash('start-tab-place', 'test' )}
						data={ [
							<BookOption
								key={ HelperString.hash('book-option-place', 'self' ) }
								timeslotGroup={ 'test' }
								forOption={ bookingOptions.MYSELF }
								forcedGuids={ _forcedGuids }
								onPress={ onPressMeeting }
								iconImage={{ uri: teamsIconPng }}
							/>
						] }
						renderItem={ ({ item }) => {
							return item;
						} }
						style={ staticStyles.themedListPaddingHorizontal0 }
					/>
				</ThemedBlock>
			</View>
		)
	}
	
	// Check if events are enabled
	if( showEvents ) {
		items.push(
			<View
				key={ HelperString.hash('start-place', 'events' ) }>
				
				<TextDivider
					text={ i18n.t( 'titles.events') }
					rowStyle={ staticStyles.textDividerMarginTop12 }
				/>
				
				<ThemedBlock
					shadow>
					
					<ThemedPressable
						key={ HelperString.hash('start-place-item', 'events' ) }
						onPress={ onPressEvents }>
						
						<ThemedItem
							accessoryLeft={<IconView icon={ <Icon icon={ IconSystemConstants.EVENT } style={ staticStyles.iconFontSize24ColorPrimary } /> } /> }
							accessoryLeftSize={ 50 }
							title={ i18n.t( 'titles.events') }
						/>
					</ThemedPressable>
				</ThemedBlock>
			</View>
		)
	}
	
	return items;
}

const staticStyles = StyleSheet.create({
	textDividerMarginTop12: {
		marginTop: 12,
	},
	themedListPaddingHorizontal0: {
		paddingHorizontal: 0,
	},
	iconFontSize24ColorPrimary: {
		fontSize: 24,
		color: colorList.ORANGE.primary,
	},
});

export default HomeBookStartPlace;
